import React from 'react';
import './Header.css';
import { useAuth } from '../hooks/useAuth';

const Header = ({ user, currentPage, onNavigate }) => {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  const getUserInitials = (email) => {
    if (!email) return 'U';
    return email.substring(0, 2).toUpperCase();
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <div className="logo">
            <div className="logo-icon">EC</div>
            <h1 className="logo-text">Evercontact.ai</h1>
          </div>
          <span className="dashboard-subtitle">Dashboard</span>
        </div>
        
        <nav className="header-nav">
          <button 
            className={`nav-btn ${currentPage === 'contact-rescue' ? 'active' : ''}`}
            onClick={() => onNavigate('contact-rescue')}
          >
            Contact Rescue
          </button>
          <button
            className={`nav-btn ${currentPage === 'evercontact-users' ? 'active' : ''}`}
            onClick={() => onNavigate('evercontact-users')}
          >
            Evercontact Users
          </button>
          <button
            className={`nav-btn ${currentPage === 'knowledge-base' ? 'active' : ''}`}
            onClick={() => onNavigate('knowledge-base')}
          >
            Knowledge Base
          </button>
        </nav>

        <div className="header-actions">
          <div className="user-profile">
            <div className="user-avatar">
              <span>{getUserInitials(user?.email)}</span>
            </div>
            <span className="user-name">{user?.email?.split('@')[0] || 'User'}</span>
            <button onClick={handleSignOut} className="sign-out-btn">
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;